import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { observer } from "mobx-react-lite";
import React from "react";
import type { VolunteerTask } from "../types";
import type { VolunteerStore } from "../store";
import { TaskSection } from "./TaskSection";

interface Props {
  store: VolunteerStore;
  task: VolunteerTask;
  isAdmin: boolean;
}

export const SortableTaskItem = observer(({ store, task, isAdmin }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: task.objectId! });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {isAdmin && (
        <div
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            touchAction: "none",
            padding: "20px 4px",
            color: "rgba(0, 0, 0, 0.45)",
            userSelect: "none",
          }}
        >
          ⠿
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <TaskSection store={store} task={task} isAdmin={isAdmin} />
      </div>
    </div>
  );
});
